'use client';
import React from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer,
} from 'recharts';

// BACKEND INTEGRATION: GET /api/admin/revenue?year=2026
const revenueData = [
  { month: 'Jan', revenue: 3200, bookings: 12 },
  { month: 'Feb', revenue: 2850, bookings: 10 },
  { month: 'Mar', revenue: 4100, bookings: 16 },
  { month: 'Apr', revenue: 5600, bookings: 21 },
  { month: 'May', revenue: 8420, bookings: 28 },
  { month: 'Jun', revenue: 0, bookings: 0 },
  { month: 'Jul', revenue: 0, bookings: 0 },
  { month: 'Aug', revenue: 0, bookings: 0 },
  { month: 'Sep', revenue: 0, bookings: 0 },
  { month: 'Oct', revenue: 0, bookings: 0 },
  { month: 'Nov', revenue: 0, bookings: 0 },
  { month: 'Dec', revenue: 0, bookings: 0 },
];

const CustomTooltip = ({ active, payload, label }: { active?: boolean; payload?: Array<{ value: number; name: string }>; label?: string }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border border-border rounded-xl shadow-card p-3">
        <p className="text-xs font-700 text-foreground mb-1">{label} 2026</p>
        {payload.map((entry, i) => (
          <p key={`tt-${i}`} className="text-xs text-muted-foreground">
            {entry.name === 'revenue' ? `Revenue: €${entry.value.toLocaleString()}` : `Bookings: ${entry.value}`}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default function RevenueChart() {
  return (
    <div className="card-base p-5 h-full">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-700 text-base text-foreground">Revenue Overview</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Monthly revenue · 2026</p>
        </div>
        <div className="bg-muted px-3 py-1.5 rounded-lg text-xs font-600 text-muted-foreground">
          2026
        </div>
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={revenueData} margin={{ top: 5, right: 5, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
          <XAxis dataKey="month" tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }} axisLine={false} tickLine={false} />
          <YAxis
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => v === 0 ? '' : `€${(v / 1000).toFixed(0)}k`}
            width={40}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="revenue"
            stroke="var(--primary)"
            strokeWidth={2.5}
            fill="url(#revenueGradient)"
            dot={false}
            activeDot={{ r: 5, fill: 'var(--primary)', strokeWidth: 0 }}
          />
        </AreaChart>
      </ResponsiveContainer>
      <div className="flex items-center gap-6 mt-2 pt-4 border-t border-border">
        <div>
          <p className="text-xs text-muted-foreground">YTD Revenue</p>
          <p className="text-lg font-800 text-foreground tabular-nums">€24,170</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Best Month</p>
          <p className="text-lg font-800 text-foreground tabular-nums">May · €8,420</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Avg / Month</p>
          <p className="text-lg font-800 text-foreground tabular-nums">€4,834</p>
        </div>
      </div>
    </div>
  );
}